import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "doctor-service-prices-price-list",
      attrs: { "data-qa": "doctor_service_prices_price_list" },
    },
    [
      _vm._l(_vm.categoryList, function ({ name, priceList }, categoryIndex) {
        return _c(
          "div",
          {
            key: categoryIndex,
            class: {
              "mb-8":
                _setup.isMobile && categoryIndex < _vm.categoryList.length - 1,
              "mb-12":
                !_setup.isMobile && categoryIndex < _vm.categoryList.length - 1,
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "text-h6 text--text mb-6",
                attrs: { "data-qa": "doctor_service_prices_category" },
              },
              [_vm._v("\n      " + _vm._s(name) + "\n    ")]
            ),
            _vm._v(" "),
            _vm._l(priceList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "doctor-service-prices-price-list__item flex-wrap",
                  class: {
                    "mb-4": _setup.isMobile && index < priceList.length - 1,
                    "mb-6": !_setup.isMobile && index < priceList.length - 1,
                  },
                  attrs: { "data-qa": "doctor_service_prices_price_item" },
                },
                [
                  _setup.isMobile
                    ? [
                        _c("div", { staticClass: "mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "text-body-1 text--text",
                              attrs: {
                                "data-qa":
                                  "doctor_service_prices_price_item_name",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.name) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          item.duration
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-body-2 text-secondary--text",
                                  attrs: {
                                    "data-qa":
                                      "doctor_service_prices_price_item_duration",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.getDurationText(item)) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.agesText
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-body-2 text-secondary--text",
                                  attrs: {
                                    "data-qa":
                                      "doctor_service_prices_price_item_ages_text",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.agesText) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-center",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text-subtitle-1 text--text",
                                attrs: {
                                  "data-qa":
                                    "doctor_service_prices_price_item_price",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.formattedPrice) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex justify-end",
                                style: {
                                  width: "180px",
                                },
                              },
                              [
                                item.hasSlots &&
                                item.isEnabledServiceDirect &&
                                !item.isEnabledCalendar
                                  ? _c(
                                      VBtn,
                                      {
                                        attrs: {
                                          block: "",
                                          depressed: "",
                                          color: "primary",
                                          "data-qa":
                                            "doctor_service_prices_price_item_show_calendar",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _setup.emitShowCalendar({
                                              synonymId: item.synonymId,
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "ui-icon-calendar-date-and-clock bg-gray-0--text mr-2",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-subtitle-1 bg-gray-0--text",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _setup.i18next.t(
                                                    "Запись онлайн",
                                                    { ns: _setup.userLanguage }
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.isEnabledCalendar
                                  ? _c(
                                      VBtn,
                                      {
                                        attrs: {
                                          depressed: "",
                                          width: "56",
                                          height: "40",
                                          "min-width": "56",
                                          color: "bg-gray-40",
                                          "data-qa":
                                            "doctor_service_prices_price_item_hide_calendar",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _setup.emit(
                                              "click:hide-calendar"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-100 h-100 d-flex align-center justify-center",
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "b-lpu-services__toggle-calendar-icon ui-icon-arrow-up icon-secondary--text",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.isEnabledCalendar,
                              expression: "item.isEnabledCalendar",
                            },
                          ],
                          staticClass: "mt-4",
                          attrs: {
                            id: `doctor-price-calendar-wrapper-${item.synonymId}`,
                            "data-qa": "doctor_service_prices_calendar_wrapper",
                          },
                        }),
                        _vm._v(" "),
                        index < priceList.length - 1
                          ? _c(VDivider, { staticClass: "mt-4" })
                          : _vm._e(),
                      ]
                    : [
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "div",
                            {
                              style: {
                                width: "calc(100% - 400px)",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-body-1 text--text",
                                  attrs: {
                                    "data-qa":
                                      "doctor_service_prices_price_item_name",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.name) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              item.duration
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-body-2 text-secondary--text",
                                      attrs: {
                                        "data-qa":
                                          "doctor_service_prices_price_item_duration",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_setup.getDurationText(item)) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.agesText
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-body-2 text-secondary--text",
                                      attrs: {
                                        "data-qa":
                                          "doctor_service_prices_price_item_ages_text",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.agesText) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between align-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-subtitle-1 text--text text-right d-flex justify-end align-center pr-6",
                                  style: {
                                    width: "130px",
                                  },
                                  attrs: {
                                    "data-qa":
                                      "doctor_service_prices_price_item_price",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.formattedPrice) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-end",
                                  style: {
                                    width: "270px",
                                  },
                                },
                                [
                                  item.hasSlots &&
                                  item.isEnabledServiceDirect &&
                                  !item.isEnabledCalendar
                                    ? _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            block: "",
                                            depressed: "",
                                            color: "primary",
                                            "data-qa":
                                              "doctor_service_prices_price_item_show_calendar",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _setup.emitShowCalendar({
                                                synonymId: item.synonymId,
                                              })
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "ui-icon-calendar-date-and-clock bg-gray-0--text mr-2",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-subtitle-1 bg-gray-0--text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _setup.i18next.t(
                                                      "Запись онлайн",
                                                      {
                                                        ns: _setup.userLanguage,
                                                      }
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.isEnabledCalendar
                                    ? _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            depressed: "",
                                            width: "56",
                                            height: "40",
                                            "min-width": "56",
                                            color: "bg-gray-40",
                                            "data-qa":
                                              "doctor_service_prices_price_item_hide_calendar",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _setup.emit(
                                                "click:hide-calendar"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-100 h-100 d-flex align-center justify-center",
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "b-lpu-services__toggle-calendar-icon ui-icon-arrow-up icon-secondary--text",
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.isEnabledCalendar,
                              expression: "item.isEnabledCalendar",
                            },
                          ],
                          staticClass: "mt-4",
                          attrs: {
                            id: `doctor-price-calendar-wrapper-${item.synonymId}`,
                            "data-qa": "doctor_service_prices_calendar_wrapper",
                          },
                        }),
                      ],
                ],
                2
              )
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.isShowMoreButtonVisible
        ? _c(
            VBtn,
            {
              staticClass: "primary--text mt-4",
              class: { "mx-auto": !_setup.isMobile },
              attrs: { color: "bg-primary", elevation: "0" },
              on: {
                click: function ($event) {
                  return _setup.emit("click:show-more-services")
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.showMoreButtonText) + "\n  ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }